import React, { useState, useRef, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { usersDropDownAction } from '../../../redux/actions/teamAction';
import errorToast from '../../toasts/errorToast';
import CustomCheckboxDropdown from '../../forms/checkBoxDropDown';

const UserSelectionModal = ({ isOpen, onClose, onSave }) => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const dropdownRef = useRef(null);

    const [userOptions, setUserOptions] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState(false);

    useEffect(() => {
        if (isOpen) {
            fetchUsers();
        }
    }, [isOpen]);

    const fetchUsers = () => {
        dispatch(usersDropDownAction({ team_id: id }, handleUsersSuccess, handleError));
    };

    const handleUsersSuccess = (data) => {
        const usersData = data.data.data.map((user) => ({
            label: user.email,
            value: user.id,
        }));
        setUserOptions(usersData);
    };

    const handleError = (error) => {
        errorToast(error?.data?.message || 'An error occurred while fetching users.');
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setDropdownOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleSave = () => {
        if (selectedUsers.length === 0) {
            errorToast('Please select at least one user.');
            return;
        }
        onSave(selectedUsers);
        fetchUsers();
        setSelectedUsers([]);
    };

    const handleClose = () => {
        onClose();
        setSelectedUsers([]);
    };

    return (
        <Modal show={isOpen} onHide={handleClose} centered backdrop="static" >
            <Modal.Header closeButton>
                <Modal.Title>Add Users</Modal.Title>
            </Modal.Header>
            <Modal.Body className='p-5'>
                <div className="d-flex flex-column justify-content-start align-items-center">
                    <div className="text-start mb-5" ref={dropdownRef}>
                        <label htmlFor="selectedUsers" className="">
                            Select Users
                        </label>
                        <CustomCheckboxDropdown
                            width='25rem'
                            options={userOptions}
                            name="selectedUsers"
                            value={selectedUsers}
                            onChange={(name, values) => setSelectedUsers(values)}
                            placeholder="Choose users"
                            dropdownOpen={dropdownOpen}
                            setDropdownOpen={setDropdownOpen}
                        />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between">
                <Button variant="secondary" onClick={handleClose}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleSave} disabled={selectedUsers.length === 0}>
                    Submit
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default UserSelectionModal;
